<style lang="stylus">
    .ednotice-box
        position absolute
        top 0
        left 0
        z-index 1000
        .ednotice-arrow
            position absolute
            svg
                width 14px;
                height 9px
                fill var(--svg-color-notice-arrow)
        &.left-arrow
            .ednotice-arrow
                svg
                    transform rotate(90deg)
        &.top-arrow
            .ednotice-arrow
                svg
                    transform rotate(180deg)
        &.right-arrow
            .ednotice-arrow
                svg
                    transform rotate(270deg)

        .ednotice
            position relative
            padding 16px
            min-width 200px
            border-radius 8px
            background var(--bg-color-tips)
            border 0.5px solid rgba(255, 255, 255, 0.2)
            box-shadow 0px 0px 4px rgba(0, 0, 0, 0.05), 0px 2px 10px rgba(0, 0, 0, 0.08)
            backdrop-filter blur(2px)

        &.useclose .ednotice
            padding-right 36px

        &.usebtn
            .ednotice
                padding-right 40px

            .ednotice-content
                margin-bottom 16px

        &.haspic
            .ednotice
                padding-right 16px

            .ednotice-content
                margin-bottom 8px

            .ednotic-picContent
                width 100%
                border-radius 6px
                margin-bottom 37px
                object-fit scale-down
                background #fff

        .ednotice-content
            font-size 12px
            line-height 16px
            color #fff

            &.wrap-content
                line-height 20px

            .library-control
                width 8px
                height 8px

        .ednotice-close
            position absolute
            right 12px
            top 12px
            width 16px
            height 16px
            border-radius 4px
            cursor pointer
            user-select none
            svg
                height 16px;
                width 16px;
                color #fff

            &:hover
                background rgba(255, 255, 255, 0.1)

        .ednotice-btn
            position absolute
            right 16px
            bottom 16px
            max-width 80%
            padding 4px 10px
            background var(--themeColor)
            border-radius 6px
            cursor pointer
            user-select none

            &:hover
                background var(--themeHover)

            p
                width 100%
                color #fff
                font-size 12px
                line-height 16px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
</style>

<template>
    <div ref="ednotice" class="ednotice-box" :class="directClass" v-show="showBox" v-transfer-dom :data-transfer="true">
        <div class="ednotice">
            <div class="ednotice-content" :class="{ 'wrap-content': wrapContent }" v-html="content"></div>
            <img v-if="picPath" :src="picPath" class="ednotic-picContent" :style="{ height: picHeight + 'px' }" alt="" />
            <div class="ednotice-close" v-if="showClose" @click="closeEvent">
                <iconSymbol name="notice-close" draggable="false" @drag.native.stop />
            </div>
            <div class="ednotice-btn" v-if="showBtn" @click="closeEvent">
                <p>{{ $t("confirm") }}</p>
            </div>
        </div>
        <div class="ednotice-arrow" :style="arrowPosition">
            <iconSymbol name="notice-arrow" draggable="false" @drag.native.stop />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class EDNotice extends Vue {
        @Prop({ required: true }) dom;
        @Prop() content;
        @Prop({ default: false }) showClose;
        @Prop({ default: false }) showBtn;
        @Prop({ default: false }) show;
        @Prop({ default: "" }) picPath;
        @Prop({ default: 95 }) picHeight;
        @Prop() forceDirect;

        showBox = false;

        get directClass() {
            let str = this.arrowType;
            if (this.showClose) str += " useclose";
            if (this.showBtn) str += " usebtn";
            if (this.picPath) str += " haspic";
            return str;
        }

        domRect;
        domZoom = 0;
        arrowType = "";
        arrowPosition = "";
        wrapContent = false;

        @Watch("show", { immediate: true })
        prepareData(nv, ov) {
            if (nv) {
                this.setNoticePosition(-1000, -1000);
                this.showBox = true;
                this.$nextTick(() => {
                    this.wrapContent = (this.$refs.ednotice as HTMLElement).getBoundingClientRect().height > 50;
                    this.caculatePosition();
                });
                setTimeout(() => {
                    this.addCloseEvent();
                }, 100);
            } else {
                this.showBox = false;
            }
        }

        setNoticePosition(x, y) {
            let notice = this.$refs.ednotice as HTMLElement;
            if (!notice) return;
            notice.style.left = `${x}px`;
            notice.style.top = `${y}px`;
        }

        getDomPosition() {
            // 获取箭头位置
            let rect = this.domRect;
            const winW = window.innerWidth,
                winH = window.innerHeight,
                dx = rect.x + rect.width / 2,
                dy = rect.y + rect.height / 2;
            let func1 = (x, y) => {
                let temp = -(winH / winW) * x;
                return y > temp;
            };
            let func2 = (x, y) => {
                let temp = -(winH / winW) * x - winH;
                return y > temp;
            };
            let func1Result = func1(dx, dy);
            let func2Result = func2(dx, dy);

            if (dx < winW / 2) {
                if (dy < winH / 2) {
                    // 第二象限
                    this.domZoom = 2;
                    return func1Result ? "top" : "left";
                } else {
                    // 第三象限
                    this.domZoom = 3;
                    return func2Result ? "left" : "bottom";
                }
            } else {
                if (dy < winH / 2) {
                    // 第一象限
                    this.domZoom = 1;
                    return func2Result ? "top" : "right";
                } else {
                    // 第四象限
                    this.domZoom = 4;
                    return func1Result ? "right" : "bottom";
                }
            }
        }

        xfitPosition(x) {
            // 边界适配
            const notice = this.$refs.ednotice as HTMLElement;
            const noticeRect = notice.getBoundingClientRect();
            if (x < 0) {
                return x;
            } else if (x + noticeRect.width > window.innerWidth) {
                return window.innerWidth - noticeRect.width - x;
            }
            return 0;
        }

        yfitPosition(y) {
            // 边界适配
            const notice = this.$refs.ednotice as HTMLElement;
            const noticeRect = notice.getBoundingClientRect();
            if (y < 0) {
                return y;
            } else if (y + noticeRect.height > window.innerHeight) {
                return window.innerHeight - noticeRect.height - y;
            }
            return 0;
        }

        caculatePosition() {
            if (!this.dom) return;
            this.domRect = this.dom.getBoundingClientRect();
            let arrowDirect = this.forceDirect ? this.forceDirect : this.getDomPosition();
            const horizontalMiddle = this.domRect.height < 72,
                verticalMiddle = this.domRect.width <= 200;
            this.arrowType = `${arrowDirect}-arrow`;
            const arrowWidth = 7; // 未旋转 箭头图形二分之一宽度
            const arrowHeight = 9;
            const notice = this.$refs.ednotice as HTMLElement;
            const noticeRect = notice.getBoundingClientRect();
            let left = this.domRect.x,
                top = this.domRect.y,
                domH = this.domRect.height,
                domW = this.domRect.width,
                noticeH = noticeRect.height,
                noticeW = noticeRect.width;
            switch (arrowDirect) {
                case "left": {
                    let topPosition = this.domZoom == 2 ? noticeH / 3 - arrowWidth : (noticeH * 2) / 3 - arrowWidth;
                    let arrowTop = horizontalMiddle ? noticeH / 2 - arrowWidth : topPosition;
                    this.arrowPosition = `left: -10px; top: ${arrowTop}px`;
                    this.setNoticePosition(left + domW + arrowWidth, top + domH / 2 - arrowTop - arrowWidth);
                    break;
                }
                case "top": {
                    let leftPosition = this.domZoom == 2 ? noticeW / 3 - arrowHeight : (noticeW * 2) / 3 - arrowHeight;
                    let arrowLeft = verticalMiddle ? noticeW / 2 - arrowHeight : leftPosition;
                    let offset = this.xfitPosition(left + domW / 2 - arrowLeft - arrowHeight);
                    this.arrowPosition = `left: ${arrowLeft - offset}px; top: -12px`;
                    this.setNoticePosition(left + domW / 2 - arrowLeft - arrowHeight + offset, top + domH + arrowHeight);
                    break;
                }
                case "right": {
                    let topPosition = this.domZoom == 2 ? noticeH / 3 - arrowWidth : (noticeH * 2) / 3 - arrowWidth;
                    let arrowTop = horizontalMiddle ? noticeH / 2 - arrowWidth : topPosition;
                    this.arrowPosition = `right: -10px; top: ${arrowTop}px`;
                    this.setNoticePosition(left - noticeRect.width - arrowWidth, top + domH / 2 - arrowTop - arrowWidth);
                    break;
                }
                case "bottom":
                    let leftPosition = this.domZoom == 2 ? noticeW / 3 - arrowHeight : (noticeW * 2) / 3 - arrowHeight;
                    let arrowLeft = verticalMiddle ? noticeW / 2 - arrowHeight : leftPosition;
                    let offset = this.xfitPosition(left + domW / 2 - arrowLeft - arrowHeight);
                    this.arrowPosition = `left: ${arrowLeft - offset}px; bottom: -13px`;
                    this.setNoticePosition(left + domW / 2 - arrowLeft - arrowHeight + offset, top - noticeRect.height - arrowHeight);
                    break;
            }
        }

        closeEvent() {
            this.showBox = false;
            this.$emit("closeTips");
            document.removeEventListener("click", this.closeEvent);
        }

        addCloseEvent() {
            document.addEventListener("click", this.closeEvent);
        }

        created() {}
        mounted() {
            window.addEventListener("resize", this.closeEvent);
        }
        beforeDestroy() {
            window.removeEventListener("resize", this.closeEvent);
        }
    }
</script>
<i18n>
{
    "zh": {
        "confirm": "我知道了"
    },
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
